import { v4 as uuidv4 } from "uuid";
import { useListenFromRenderer } from "../message";
import { postToRenderer } from "../message/utils";
import { fetchGatewayInferenceJob } from "./shared/fetch-inference-job";
import { getTargetEditorImage } from "./shared/target-editor-image";

const TOOL_NAME = "Inpainting";

const callInpainting = async (
	prompt: string,
	messageId: string,
	jwt: string,
	tool_document_id: string,
) => {
	const { success } = await getTargetEditorImage({
		commandName: TOOL_NAME,
		resultLayerName: TOOL_NAME,
		requireSelectionBounds: true,
		useLayerBoundsAsSource: true,
		includeMask: true,
		applyMaskToResultLayer: true,
		processImage: async ({ imageBase64, maskBase64, executionContext }) => {
			const data = {
				inputs: {
					$img: imageBase64,
					$mask: maskBase64 ?? "",
					$text_prompt: prompt,
				},
				jwt,
				tool_document_id,
			};
			return fetchInpainting(data, executionContext, messageId);
		},
	});
	return success;
};

export async function fetchInpainting(
	params: {
		inputs: {
			$img: string;
			$mask: string;
			$text_prompt: string;
		};
		jwt: string;
		tool_document_id: string;
	},
	executionContext: any,
	messageId: string,
): Promise<string | false> {
	return fetchGatewayInferenceJob(params, executionContext, messageId);
}

export function useListenInpaintingMessage() {
	useListenFromRenderer([
		{
			key: "inpainting",
			onMessage: async (message) => {
				const success = await callInpainting(
					message.values.prompt,
					message.id,
					message.values.jwt,
					message.values.tool_document_id,
				);
				postToRenderer([
					{
						key: "finish",
						id: uuidv4(),
						values: {
							id: message.id,
							status: success ? "success" : "error",
						},
					},
				]);
			},
		},
	]);
}
